import type { View } from './NavContext.js'

export interface ModuleDef {
  key: View
  label: string
  /** One short line shown on the Home card. */
  desc: string
  /** Hidden unless the user holds this permission (the API enforces it as well). */
  permission?: string
}

/** Single source for the sidebar and the Home cards, so they can never drift apart. */
export const MODULES: ModuleDef[] = [
  { key: 'dashboard', label: 'Dashboard', desc: "Today's numbers at a glance" },
  { key: 'enquiries', label: 'Enquiries', desc: 'Customer enquiries and quotations' },
  { key: 'bookings', label: 'Bookings', desc: 'Confirmed bookings and consignments' },
  { key: 'planning', label: 'Vehicle Planning', desc: 'Assign vehicles and drivers' },
  { key: 'trips', label: 'Trips', desc: 'Dispatch, lorry receipts, POD and tracking' },
  { key: 'petty-cash', label: 'Petty Cash', desc: 'Branch cash, expenses and daily closing' },
  { key: 'billing', label: 'Billing', desc: 'Invoices, receipts and receivables' },
  { key: 'payables', label: 'Payables', desc: 'Vendor, broker and driver payments' },
  { key: 'profitability', label: 'Profitability', desc: 'Profit by trip, vehicle, customer and route' },
  { key: 'reports', label: 'Reports', desc: '53 reports with Excel, PDF and CSV export' },
  { key: 'masters', label: 'Masters', desc: 'Customers, vehicles, drivers, rates and more' },
  // Stage 12 §3: Owner-only. Hidden here, enforced by the API as well.
  { key: 'settings', label: 'Settings', desc: 'Company, users, notifications and audit trail', permission: 'tenant_settings.update' },
]
